module.exports = __webpack_public_path__ + "static/ses-2021-about-us-49ccafc24ce4a658668bb0bc7ca67613.pdf";